module.exports = __webpack_public_path__ + "static/media/001.e0f5d315.png";